<template>
  <base-button
    class="small-button"
    :text="text"
    :is-disabled="isDisabled"
    :is-loading="false"
  >
    <slot />
  </base-button>
</template>

<script setup lang="ts">
import BaseButton from '@/components/common/BaseButton.vue'

export interface Props {
  text: string;
  isDisabled?: boolean
}
withDefaults(defineProps<Props>(), { isDisabled: false })
</script>

<style lang="scss">
.small-button {
  padding: 10px 18px 12px 18px;
  color: $white;
  font-family: $font-bold;
  font-size: 14px;
  line-height: 14px;

  & .base-button__content {
    gap: 4px;
  }
}
</style>
